import { ActionTree } from "vuex";
import { CalendarState, Calendar } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";
import Qs from "qs";

const actions: ActionTree<CalendarState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    const paramsHash = {
      params: params,
      paramsSerializer: function (params: object) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }

    return rootGetters['hcs/client'].get('/calendars', paramsHash)
      .then((response: AxiosResponse) => {
        const calendars: Calendar[] = response.data;
        commit('setCalendars', calendars)
        return calendars
      })
  },
  create({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].post('/calendars', params)
      .then((response: AxiosResponse) => {
        const calendar: Calendar = response.data;
        commit('addCalendar', calendar)
        return calendar
      })
  },
  update({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].patch(`/calendars/${params.id}`, params)
      .then((response: AxiosResponse) => {
        const calendar: Calendar = response.data;
        commit(('updateCalendar'), calendar)
        return calendar
      })
  },
  delete({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].delete(`/calendars/${id}`)
      .then((response: AxiosResponse) => {
        commit(('deleteCalendar'), id)
      })
  }
}

export default actions;
